import axios from 'axios';

const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

/**
 * Upload a file to the file storage API.
 * - folder: optional folder path, defaults to 'stories'
 * - onProgress: (0..100) progress callback
 */
export async function uploadToFileStorage(file, {
  folder = 'stories',
  onProgress,
}) {
  const formData = new FormData();
  formData.append('file', file);
  if (folder) {
    formData.append('folder', folder);
  }

  const response = await axios.post('https://api.learnxtrasoftwares.com/api/admin/upload-file', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      ...getAuthHeader(),
    },
    onUploadProgress: (progressEvent) => {
      if (onProgress) {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        onProgress(percentCompleted);
      }
    },
  });

  return response.data;
}

/**
 * Delete a file from the file storage API.
 * - fileId: unique ID of the file to delete
 * - folder: optional folder path
 */
export async function deleteFile(fileId, { folder = 'stories' }) {
  const response = await axios.delete(`https://api.learnxtrasoftwares.com/api/admin/delete-file/${fileId}?folder=${folder}`, {
    headers: {
      ...getAuthHeader(),
    },
  });
  return response.data;
}